import { render, staticRenderFns } from "./mainprojecttable.vue?vue&type=template&id=f5fd94b6"
import script from "./mainprojecttable.vue?vue&type=script&lang=js"
export * from "./mainprojecttable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports